import styled from '@emotion/styled';
import { Nunito, ColorPrimary } from '../../../../shared/GlobalStyles';

export const HeaderText = styled('h2')`
  font-family: ${Nunito};
  color: ${props => props.theme.textColor};
  text-align: center;
  align-self: center;
`;